import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ApplicationState, WithScope } from '@mews-commander/types';
import { getCheckedReservationsAvailabilityBlockIds } from '../../selectors';
import { AvailabilityBlockCardProps } from './AvailabilityBlockCard';

export const connectAvailabilityBlockCard = connect<AvailabilityBlockCardProps, {}, WithScope, ApplicationState>(
    createStructuredSelector({
        source: getCheckedReservationsAvailabilityBlockIds,
    })
);
